import { RelevantPhrasesErrors } from '../service/RelevantPhrasesHelpers/RelevantPhrasesHelpers';
import { RelevantPhrasesEditorValue } from '../typings/relevantPhrases';

export const INIT_CAMPAIGNS_RELEVANT_PHRASES_EDITORS = 'INIT_CAMPAIGNS_RELEVANT_PHRASES_EDITORS';
export type INIT_CAMPAIGNS_RELEVANT_PHRASES_EDITORS = typeof INIT_CAMPAIGNS_RELEVANT_PHRASES_EDITORS;

export interface InitCampaignsRelevantPhrasesEditorsItemData {
    editorId: string;
    value: RelevantPhrasesEditorValue;
}

export interface InitCampaignsRelevantPhrasesEditors {
    type: INIT_CAMPAIGNS_RELEVANT_PHRASES_EDITORS;
    editors: InitCampaignsRelevantPhrasesEditorsItemData[];
}

export function initCampaignsRelevantPhrasesEditors(
    editors: InitCampaignsRelevantPhrasesEditorsItemData[]
): InitCampaignsRelevantPhrasesEditors {
    return {
        type: INIT_CAMPAIGNS_RELEVANT_PHRASES_EDITORS,
        editors
    };
}

export const OPEN_CAMPAIGN_RELEVANT_PHRASES_EDITOR = 'OPEN_CAMPAIGN_RELEVANT_PHRASES_EDITOR';
export type OPEN_CAMPAIGN_RELEVANT_PHRASES_EDITOR = typeof OPEN_CAMPAIGN_RELEVANT_PHRASES_EDITOR;

export interface OpenCampaignRelevantPhrasesEditor {
    type: OPEN_CAMPAIGN_RELEVANT_PHRASES_EDITOR;
    editorId: string;
}

export function openCampaignRelevantPhrasesEditor(editorId: string): OpenCampaignRelevantPhrasesEditor {
    return {
        type: OPEN_CAMPAIGN_RELEVANT_PHRASES_EDITOR,
        editorId
    };
}

export const CLOSE_CAMPAIGN_RELEVANT_PHRASES_EDITOR = 'CLOSE_CAMPAIGN_RELEVANT_PHRASES_EDITOR';
export type CLOSE_CAMPAIGN_RELEVANT_PHRASES_EDITOR = typeof CLOSE_CAMPAIGN_RELEVANT_PHRASES_EDITOR;

export interface CloseCampaignRelevantPhrasesEditor {
    type: CLOSE_CAMPAIGN_RELEVANT_PHRASES_EDITOR;
    editorId: string;
}

export function closeCampaignRelevantPhrasesEditor(editorId: string): CloseCampaignRelevantPhrasesEditor {
    return {
        type: CLOSE_CAMPAIGN_RELEVANT_PHRASES_EDITOR,
        editorId
    };
}

export const RESET_CAMPAIGN_RELEVANT_PHRASES_EDITOR = 'RESET_CAMPAIGN_RELEVANT_PHRASES_EDITOR';
export type RESET_CAMPAIGN_RELEVANT_PHRASES_EDITOR = typeof RESET_CAMPAIGN_RELEVANT_PHRASES_EDITOR;

export interface ResetCampaignRelevantPhrasesEditorAction {
    type: RESET_CAMPAIGN_RELEVANT_PHRASES_EDITOR;
    editorId: string;
    value: RelevantPhrasesEditorValue;
}

export function resetCampaignRelevantPhrasesEditor(
    editorId: string,
    value: RelevantPhrasesEditorValue
): ResetCampaignRelevantPhrasesEditorAction {
    return {
        type: RESET_CAMPAIGN_RELEVANT_PHRASES_EDITOR,
        editorId,
        value
    };
}

export const TOGGLE_CAMPAIGN_RELEVANT_PHRASES = 'TOGGLE_CAMPAIGN_RELEVANT_PHRASES';
export type TOGGLE_CAMPAIGN_RELEVANT_PHRASES = typeof TOGGLE_CAMPAIGN_RELEVANT_PHRASES;

export interface ToggleCampaignRelevantPhrases {
    type: TOGGLE_CAMPAIGN_RELEVANT_PHRASES;
    editorId: string;
}

export function toggleCampaignRelevantPhrases(editorId: string): ToggleCampaignRelevantPhrases {
    return {
        type: TOGGLE_CAMPAIGN_RELEVANT_PHRASES,
        editorId
    };
}

export const CHANGE_LIMIT_CAMPAIGN_RELEVANT_PHRASES_EDITOR = 'CHANGE_LIMIT_CAMPAIGN_RELEVANT_PHRASES_EDITOR';
export type CHANGE_LIMIT_CAMPAIGN_RELEVANT_PHRASES_EDITOR = typeof CHANGE_LIMIT_CAMPAIGN_RELEVANT_PHRASES_EDITOR;

export interface ChangeLimitCampaignRelevantPhrasesEditor {
    type: CHANGE_LIMIT_CAMPAIGN_RELEVANT_PHRASES_EDITOR;
    editorId: string;
    limit: string;
}

export function changeLimitCampaignRelevantPhrasesEditor(
    editorId: string,
    limit: string
): ChangeLimitCampaignRelevantPhrasesEditor {
    return {
        type: CHANGE_LIMIT_CAMPAIGN_RELEVANT_PHRASES_EDITOR,
        editorId,
        limit
    };
}

export const SELECT_GOAL_CAMPAIGN_RELEVANT_PHRASES_EDITOR = 'SELECT_GOAL_CAMPAIGN_RELEVANT_PHRASES_EDITOR';
export type SELECT_GOAL_CAMPAIGN_RELEVANT_PHRASES_EDITOR = typeof SELECT_GOAL_CAMPAIGN_RELEVANT_PHRASES_EDITOR;

export interface SelectGoalCampaignRelevantPhrasesEditor {
    type: SELECT_GOAL_CAMPAIGN_RELEVANT_PHRASES_EDITOR;
    editorId: string;
    goalId: string;
}

export function selectGoalCampaignRelevantPhrasesEditor(
    editorId: string,
    goalId: string
): SelectGoalCampaignRelevantPhrasesEditor {
    return {
        type: SELECT_GOAL_CAMPAIGN_RELEVANT_PHRASES_EDITOR,
        editorId,
        goalId
    };
}

export const SHOW_RELEVANT_RHRASES_EDITOR_ERRORS = 'SHOW_RELEVANT_RHRASES_EDITOR_ERRORS';
export type SHOW_RELEVANT_RHRASES_EDITOR_ERRORS = typeof SHOW_RELEVANT_RHRASES_EDITOR_ERRORS;

export interface ShowRelevantPhrasesEditorErrors {
    type: SHOW_RELEVANT_RHRASES_EDITOR_ERRORS;
    editorId: string;
    errors: RelevantPhrasesErrors;
}

export function showRelevantPhrasesEditorErrors(
    editorId: string,
    errors: RelevantPhrasesErrors
): ShowRelevantPhrasesEditorErrors {
    return {
        type: SHOW_RELEVANT_RHRASES_EDITOR_ERRORS,
        editorId,
        errors
    };
}

export type RelevantPhrasesEditorAction =
    | OpenCampaignRelevantPhrasesEditor
    | CloseCampaignRelevantPhrasesEditor
    | ToggleCampaignRelevantPhrases
    | ChangeLimitCampaignRelevantPhrasesEditor
    | SelectGoalCampaignRelevantPhrasesEditor
    | ShowRelevantPhrasesEditorErrors
    | InitCampaignsRelevantPhrasesEditors
    | ResetCampaignRelevantPhrasesEditorAction;
